import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { PromoBanner } from './components/PromoBanner';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { AppointmentPage } from './pages/AppointmentPage';
import { ContactPage } from './pages/ContactPage';
// Scroll to top on route change
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <div className="min-h-screen bg-white font-sans flex flex-col" data-id="element-0" data-mp="2wka0us2ft12s">
      <ScrollToTop data-id="element-1" data-mp="2whx9xpepbgdl" />
      <PromoBanner data-id="element-2" data-mp="28ufpyg1ohml6" />
      <Header data-id="element-3" data-mp="28tw4ipctkg2e" />

      <main className="flex-grow" data-id="element-4" data-mp="28te1n9vnj3li">
        <Routes data-id="element-5" data-mp="28sbbj465l56n">
          <Route path="/" element={<HomePage data-id="element-7" data-mp="23vupqgmff2wq" />} data-id="element-6" data-mp="28s31dk1f0dz5" />
          <Route path="/about" element={<AboutPage data-id="element-9" data-mp="23t8hsfvmildz" />} data-id="element-8" data-mp="23ujkecdc1n3i" />
          <Route path="/services" element={<ServicesPage data-id="element-11" data-mp="3iiweam7rne26" />} data-id="element-10" data-mp="3ijxsv0nzqion" />
          <Route path="/appointment" element={<AppointmentPage data-id="element-13" data-mp="3mlj6io8cn0zw" />} data-id="element-12" data-mp="3ijpc2xoqyt86" />
          <Route path="/contact" element={<ContactPage data-id="element-15" data-mp="3mjq3diwy2ywn" />} data-id="element-14" data-mp="3mkhm3t5g125i" />
        </Routes>
      </main>

      <Footer data-id="element-16" data-mp="3rbzomln47asl" />
    </div>;
}